import { pickBy } from 'lodash'

import { db, storage } from 'data/firebase'

const fieldReportsKey = 'reports'

// TODEBUG: toggle next 2 lines
const fullReportsKey = 'fullReports'
//const fullReportsKey = 'fullReportsTemp'

export const createUser = (id, email) =>
  db.ref(`users/${id}`).set({ email })

export const createOrUpdateFullReport = (id, data) => {
  const definedData = pickBy(data)
  return db.ref(`${fullReportsKey}/${id}`).set(definedData)
}

export const deleteFullReports = () =>
  db.ref(fullReportsKey).set({})

export const getImageURL = (imageRef, thumbnail) => {
  let ref = imageRef

  if (thumbnail) ref = `${imageRef.replace('images', 'thumbs')}_256_thumb`

  return storage.ref(ref).getDownloadURL()
}

export const getReport = (id) =>
  db.ref(`${fieldReportsKey}/${id}`).once('value')

export const getFieldReports = () =>
  db.ref(fieldReportsKey).once('value')

export const getFullReport = (id) =>
  db.ref(`${fullReportsKey}/${id}`).once('value')

export const getFullReports = () =>
  db.ref(fullReportsKey).once('value')

export const getReportPdfUrl = (id) =>
  storage.ref(`pdfs/${id}.pdf`).getDownloadURL()


// WEBPACK FOOTER //
// ./src/data/db.js